import { useInvalidate } from '@refinedev/core';

import Cookies from 'js-cookie';
import { useSnackbar } from '@rrexpress/core';

import { useModal } from '@/hooks/useModal';
import useUser from '@/modules/user/application/user';

import UserManagementForm from './form';

type UserManagementUpdateProps = {
  data: IUser;
};

const UserManagementUpdate = ({ data }: UserManagementUpdateProps) => {
  const { updateUser, loadingUpdate } = useUser();
  const { show } = useSnackbar();
  const { close } = useModal();
  const invalidate = useInvalidate();
  const userLoginData = JSON.parse(Cookies.get('user_login') as string);

  async function handleOnSubmit(val: any) {
    const payload = {
      actor_user_id: userLoginData.userId,
      branch_id: val.branch_id,
      email: val.email,
      first_name: val.first_name,
      last_name: val.last_name,
      phone_number: val.phone_number,
      role_id: val.role_id,
      row_version: data.row_version,
      status: data.status,
      tenant_id: data.tenant_id,
      user_id: data.user_id,
      user_name: data.user_name,
      is_send_confirmation_link: val?.is_send_confirmation_link || false,
    };

    try {
      await updateUser(data.user_id, payload);
      invalidate({ resource: 'cp-users', invalidates: ['list'] });
      close();
      show('Berhasil mengubah data user', 'success');
    } catch (error) {
      show('Gagal mengubah data user', 'error');
    }
  }

  return (
    <div className="p-4">
      <UserManagementForm
        loading={loadingUpdate}
        initialValue={data}
        onFinish={handleOnSubmit}
        type="update"
      />
    </div>
  );
};

export default UserManagementUpdate;
